var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('purchaseCheques.purchaseCheques'),"description":_vm.$t('purchaseCheques.fromHereYouCanControlThepurchaseCheques')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('purchaseCheques.FindACheck'),"emptyTableText":_vm.$t('purchaseCheques.thereAreNopurchaseCheques'),"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"buttonRole":_vm.$user.role.purchase_cheques_add,"statusSearch":true,"statusValues":[
          { title: _vm.$t('purchaseCheques.active'), value: '' },
          { title: _vm.$t('purchaseCheques.Waiting'), value: 0 },
          { title: _vm.$t('purchaseCheques.driven'), value: 1 }
        ],"cloumns":[
          {
            column: 'code',
            title: _vm.$t('purchaseCheques.batch'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'client_type',
            title: _vm.$t('purchaseCheques.supplierName'),
            type: 'clintLink',
            sort: true
          },
          {
            column: 'safe_id',
            title: _vm.$t('purchaseCheques.Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true
          },
          {
            column: 'created_date',
            title: _vm.$t('purchaseCheques.RegistrationDate'),
            type: 'text',
            sort: true
          },
          {
            column: 'date',
            title: _vm.$t('purchaseCheques.paymentDate'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: _vm.$t('purchaseCheques.thatsAbout'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: _vm.$t('purchaseCheques.amount'),
            type: 'text',
            sort: true
          },
          {
            column: 'payment_method_id',
            title: _vm.$t('purchaseCheques.PaymentMethod'),
            type: 'link',
            to: 'paymentMethod',
            sort: true,
            link: false
          },
          {
            column: 'user_name',
            title: 'اسم المسئول',
            type: 'text',
            sort: true
          },
          {
            column: 'stat',
            title: _vm.$t('purchaseCheques.active'),
            type: 'status',
            sort: true,
            values: [
              {
                title: _vm.$t('purchaseCheques.Waiting'),
                value: 0,
                color: 'info'
              },
              {
                title: _vm.$t('purchaseCheques.driven'),
                value: 1,
                color: 'success'
              },
              {
                title: _vm.$t('purchaseCheques.refused'),
                value: 2,
                color: 'danger'
              }
            ]
          },
          {
            column: 'options',
            title: _vm.$t('purchaseCheques.settings'),
            type: 'options',
            options: [
              { name: 'show' },
              { name: 'printPurchaseCheque', role: true },
              {
                name: 'edit',
                role: _vm.$user.admin || _vm.$user.role.purchase_cheques_edit
              },
              { name: 'file' },
              {
                name: 'delete',
                role: _vm.$user.admin || _vm.$user.role.purchase_cheques_delete
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }